import React, { FC } from 'react'
import { Spacer } from 'components/Utility'
import { ErrorMessage } from './index'

type Props = {
  name: string
  code: string
  description: string
  discountType: string
  discountAmount: number
  discountRate: number
  maxDiscount: number
  minAmount: number
  storeIds: string[]
  couponCodes: string[]
}

const CouponError: FC<Props> = (props) => {
  const {
    name,
    code,
    description,
    discountType,
    discountAmount,
    discountRate,
    maxDiscount,
    minAmount,
    storeIds,
    couponCodes,
  } = props

  return (
    <div>
      <Spacer size={24} />
      {name === '' && (
        <>
          <ErrorMessage caution={'クーポン名を入力してください。'} id={'name'} />
          <Spacer size={12} />
        </>
      )}
      {couponCodes.includes(code) && (
        <>
          <ErrorMessage
            caution={'同じクーポンコードが存在します。異なるクーポンコードを入力してください。'}
            id={'code'}
          />
          <Spacer size={12} />
        </>
      )}
      {code.length === 8 && (
        <>
          <ErrorMessage caution={'クーポンコードは8桁外で入力してください。'} id={'code'} />
          <Spacer size={12} />
        </>
      )}
      {description === '' && (
        <>
          <ErrorMessage caution={'クーポン説明文を入力してください。'} id={'description'} />
          <Spacer size={12} />
        </>
      )}
      {discountAmount === 0 && discountRate === 0 && (
        <>
          <ErrorMessage
            caution={`割引${discountType === 'flat_rate' ? '金額' : '率'}を入力してください。`}
            id={'discount-rate'}
          />
          <Spacer size={12} />
        </>
      )}
      {discountType === 'percent' && maxDiscount === 0 && (
        <>
          <ErrorMessage caution={'割引上限額を入力してください。'} id={'max-discount'} />
          <Spacer size={12} />
        </>
      )}
      {minAmount > 0 && minAmount <= 50 && (
        <>
          <ErrorMessage caution={'最小決済金額は50円以上で入力してください。'} id={'min-amount'} />
          <Spacer size={12} />
        </>
      )}
      {minAmount > 0 && minAmount <= discountAmount && (
        <>
          <ErrorMessage caution={'最小決済金額は割引金額より大きい数値を入力してください。'} id={'min-amount'} />
          <Spacer size={12} />
        </>
      )}
      {storeIds.some((storeId) => storeId === '') && (
        <>
          <ErrorMessage caution={'利用できる店舗を選択してください。'} id={'stores'} />
          <Spacer size={12} />
        </>
      )}
    </div>
  )
}

export default CouponError
